import React,{useState, useEffect, useLayoutEffect} from 'react'
import './meTree.css'
import {Read} from '../Shared/Api'


const TreeView = ({onChange, Entity='Nodes', Id='2',selected, layout=true}) => {

    const [loaded, Load] = useState(false)
    const [items, Items]= useState([])
    const [tree, Tree]= useState([])
    const levels = ['Course', 'Soora', 'Section']
   
    useEffect(() => {

        if(!loaded) {
            Read(`moshaf/${Entity}/${Id}`, Items, Load)
            //alert(`Tree Read ${Entity} ${Id} ${items.length}`)
        }

        if(items?.length>0) {
            let course, soora, nodes = []
            let nc=0, ns=0
            
            items.forEach(item => {
                if(nc!==item.CourseId){
                    nodes.push({id:item.CourseId, text:`${item.CourseId} - ${item.Course}`, title:`${item.Course_}`, 
                        page: (Id==='9'?item.SectionId:item.PageId), nodes:[]})
                    nc=item.CourseId
                    course=nodes[nodes.length-1]
                    ns=0
                }
               
                if(ns!==item.SooraId){
                    course.nodes.push({id:item.SooraId, text:`${item.SooraId} - ${item.Soora}`, title:`${item.Soora_}`, 
                        page: (Id==='9'?item.SectionId:item.PageId), nodes:[]})
                    ns=item.SooraId
                    soora=course.nodes[course.nodes.length-1]
                }

                soora.nodes.push({id:item.SectionId, text:`${item.Section}`, title:`${item.Section_}`, 
                    page: (Id==='9'?item.SectionId:item.PageId)})
            })
            Tree(nodes)
            //console.log('Tree',nodes); alert(items.length)
        }
    }, [loaded])    

    useLayoutEffect (()=>{  // like useEffect but synchronously after all DOM
        if(selected>0) {
            var nodes = document.querySelectorAll(`li`)
            nodes.forEach(function(node) {
                if(node.id.startsWith(`${Id}-`)) {
                    //alert(`node=${node.id} class=${node.classList} selected=${selected}`)
                    if(node.id.endsWith(`-${selected}`)) {
                        if (!node.classList.contains('selected')) {
                            node.classList.add('selected')
                        }
                        
                        /*
                        let parent = node;
                        for (let i = 0; i < levels.length-1; i++) {
                            parent = parent.parentElement.parentElement;
                            if (!parent.classList.contains('collapsed')) {
                                parent.classList.add('collapsed')
                            } 
                        }
                        */
                    }
                    else {
                        if (node.classList.contains('selected')) {
                            node.classList.remove('selected')
                        } 
                    }
                }
            })
        }
    },[selected])


    const onCollapse = (item) => {
        var nodes = document.querySelectorAll(`ul`)
        nodes.forEach(function(node) {
            if(node.id.startsWith(`meTree-`)) {
                if (!node.classList.contains('collapsed')) {
                    node.classList.add('collapsed')
                } 
            }
        })

        var ul = item.querySelector('ul');
        if (ul) {
            for (let i = 1; i < levels.length; i++) {
                if (item.classList.contains(`Node${i}`)) {

                    var nodes = item.querySelectorAll(`.Node${i+1}`)
                    nodes.forEach(function(node) {
                        if (node.classList.contains('collapsed')) {
                            node.classList.remove('collapsed')    
                        } else {
                            node.classList.add('collapsed')
                        }
                    })
                }
            }                  
        }
    }  
     
     
    const onNode = (e, id) => {
        
        if(e && id>0) {
            
            onCollapse(e.target.parentElement)

            document.cookie = `meSafha=${id}`

            onChange && onChange(id)            
        }
    }
    
    return (
        loaded ? 
        <div id="treeContainer" className="TreeView" >   

        <ul id="meTree" key={`meTree-${levels[0]}`} >
        { tree.map(course => (
            <li className="Node1" value={course.id} key={`Node1-${course.id}`}>
                <span className="label" onClick={(e) => onNode(e,course.page)} key={`${levels[0]}-${course.id}`}>{course.text}</span>
            
            <ul id="meTree-2" key={`meTree-${levels[1]}`}>
            { course.nodes.map(soora => (
                    <li className='Node2 collapsed' key={`Node2-${soora.id}`}>
                        <span className="label" onClick={(e) => onNode(e,soora.page)} key={`${levels[1]}-${soora.id}`}>{soora.text}</span>
                    
                    <ul id="meTree-3" key={`meTree-${levels[2]}`}>
                    { soora.nodes.map(safha => (
                        <li className={selected===safha.id ? 'Node3 selected' : 'Node3 collapsed'} id={`${Id}-${safha.page}`}  key={`Node3-${safha.id}`}>
                            <span className="label"  title={safha.title} onClick={(e) => onNode(e,safha.page)} key={`${levels[2]}-${safha.id}`}>{safha.text}</span>
                        </li>

                        ))
                    }                
                    </ul>
                    </li>
                    ))
                }                
            </ul>
            </li>
            ))
        }
    </ul> 

    </div> 

    :
    <div>{Entity} are loading...</div> 
    )
}

export default TreeView